export default "__VITE_ASSET__D2IS42$c__"